import React from "react";
// Css
import "./loading.scss";

export default function Loading() {
  return  <div className="loader" />
}